export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const GET_PROFILE = "GET_PROFILE";
export const GET_PROFILES = "GET_PROFILES";
export const GET_REPOS = "GET_REPOS";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const CLEAR_PROFILE = "CLEAR_PROFILE";
export const PROFILE_ERROR = "PROFIL_ERROR";
export const ADD_COMMENT = "ADD_COMMENT";
export const REMOVE_BOOK = "REMOVE_BOOK";
export const GET_TRIGGERS = "GET_TRIGGERS";
export const GET_ACTIVITY = "GET_ACTIVITY";
export const GET_BOOKS = "GETBOOKS";
export const AUTH = "AUTH";
export const GET_ERRORS = "GET_ERRORS";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SHOW_BOOKS = "SHOWBOOKS";
export const BOOK_LOADING = "BOOK_LOADING";
export const GET_BOOK = "GET_BOOK";
export const CREATE_BOOK = "CREATE_BOOK";
export const CATEGORY = "CATEGORY";
